function Redirector() {
  window.location.href =
    "https://docs.google.com/document/d/1QZ5vP8O4mKbyqiEi5u-2bcAygisCSmoGJ4kaP3UPg78/view#heading=h.k8agjkwcf02k";
  return null;
}

export default Redirector;
